/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SupportRouteImport } from './routes/support'
import { Route as AdminSubscribersRouteImport } from './routes/admin.subscribers'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubscribersRoute = AdminSubscribersRouteImport.update({
  id: '/admin/subscribers',
  path: '/admin/subscribers',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/admin/subscribers': typeof AdminSubscribersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/admin/subscribers': typeof AdminSubscribersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/support': typeof SupportRoute
  '/admin/subscribers': typeof AdminSubscribersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/privacy' | '/sign-in' | '/support' | '/admin/subscribers'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/privacy' | '/sign-in' | '/support' | '/admin/subscribers'
  id:
    | '__root__'
    | '/'
    | '/privacy'
    | '/sign-in'
    | '/support'
    | '/admin/subscribers'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivacyRoute: typeof PrivacyRoute
  SignInRoute: typeof SignInRoute
  SupportRoute: typeof SupportRoute
  AdminSubscribersRoute: typeof AdminSubscribersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/subscribers': {
      id: '/admin/subscribers'
      path: '/admin/subscribers'
      fullPath: '/admin/subscribers'
      preLoaderRoute: typeof AdminSubscribersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivacyRoute: PrivacyRoute,
  SignInRoute: SignInRoute,
  SupportRoute: SupportRoute,
  AdminSubscribersRoute: AdminSubscribersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
